import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

import { BaseForm } from './models/base-form';

@Injectable()
export class InputFormProvider {
  constructor() { }

  /**
   * 画面項目リスト作成.
   *
   * @param Constで定義した画面項目
   * @returns 画面項目のリスト
   */
  generateItems(items: Object[]) {
    const formItems = items.map(item => new BaseForm(item));
    return formItems.sort((a, b) => a.order - b.order);
  }
  
  /**
   * FormGroupに変換.
   *
   * @returns FormGroup
   */
  toFormGroup(items: BaseForm[]) {
    const group: any = {};

    items.forEach(item => {
      const validators: ValidatorFn[] = [];
      if (item.required) {
        validators.push(Validators.required);
      }
      if (item.validatorPattern != null) {
        validators.push(Validators.pattern(item.validatorPattern.pattern));
      }
      group[item.key] = new FormControl((item.value!=null ? item.value : ''), validators);
    });

    return new FormGroup(group);
  }
}



// WEBPACK FOOTER //
// ./src/providers/input-form/input-form.ts